import tw, { styled } from "twin.macro"

export const StyledImage = styled.img`
    ${tw`w-full h-2 absolute bottom-0 left-0`}    
`